import React from "react";

export const AppContext = React.createContext([{}, () => {}]);

export const AppProvider = (props) => {
  const [story, storyDispatch] = React.useReducer(reducer, {});
  const [stories, storiesDispatch] = React.useReducer(listReducer, []);
  const [episodes, episodesDispatch] = React.useReducer(listReducer, []);
  const [episode, episodeDispatch] = React.useReducer(listReducer, []);
  const [genres, genresDispatch] = React.useReducer(listReducer, []);
  const [chat, setChat] = React.useState(false);

  React.useEffect(() => {
    // if (Boolean(localStorage.getItem("chat"))) {
    //   setChat(true);
    // }
  }, []);

  // React.useEffect(() => {
  //   // localStorage.setItem("chat", chat);
  // }, [chat]);

  return (
    <AppContext.Provider
      value={{
        story,
        storyDispatch,
        stories,
        storiesDispatch,
        episode, 
        episodeDispatch,
        episodes,
        episodesDispatch,
        genres,
        genresDispatch,
        chat,
        setChat,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};

const reducer = (state = {}, action) => {
  switch (action.type) {
    case "set":
      return action.payload;
    case "reset":
      return {};
    default:
      return state;
  }
};

const listReducer = (state = [], action) => {
  switch (action.type) {
    case "set":
      return action.payload;
    case "add":
      return [...state, action.payload];
    case "remove":
      return [
        ...state.slice(0, action.payload),
        ...state.slice(action.payload + 1),
      ];
    case "addall":
      return [...state, ...action.payload];
    case "reset":
      return [];
    default:
      return state;
  }
};
